import type { CSSProperties, FocusEvent, MouseEvent } from 'react'

export const googleLogoStyle: CSSProperties = {
    display: 'block',
    flexShrink: 0,
}

export const getGoogleButtonStyle = (disabled?: boolean): CSSProperties => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: '12px',
    width: '100%',
    padding: '12px 24px',
    backgroundColor: '#ffffff',
    border: '1px solid rgba(0,0,0,0.12)',
    borderRadius: '8px',
    cursor: disabled ? 'not-allowed' : 'pointer',
    opacity: disabled ? 0.6 : 1,
    fontFamily: 'Roboto, sans-serif',
    fontSize: '15px',
    fontWeight: 500,
    lineHeight: 1.75,
    letterSpacing: '0.25px',
    color: '#1F1F1F',
    transition: 'background-color 0.2s, box-shadow 0.2s',
    boxShadow: 'none',
    outline: 'none',
})

export const handleGoogleButtonMouseEnter = (event: MouseEvent<HTMLButtonElement>, disabled?: boolean): void => {
    if (!disabled) event.currentTarget.style.backgroundColor = '#f8f8f8'
}

export const handleGoogleButtonMouseLeave = (event: MouseEvent<HTMLButtonElement>, disabled?: boolean): void => {
    if (!disabled) event.currentTarget.style.backgroundColor = '#ffffff'
}

export const handleGoogleButtonFocus = (event: FocusEvent<HTMLButtonElement>): void => {
    event.currentTarget.style.boxShadow = '0 0 0 3px rgba(66,133,244,0.3)'
}

export const handleGoogleButtonBlur = (event: FocusEvent<HTMLButtonElement>): void => {
    event.currentTarget.style.boxShadow = 'none'
}
